import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

import { OpinButtonModule } from '../../atoms/button/button.module';
import { OpinIconModule } from '../../atoms/icon/icon.module';
import { OpinLabelModule } from '../../atoms/label/label.module';

import { DialogDetailsComponent } from './dialog-details.component';

@NgModule({
  exports: [DialogDetailsComponent],
  declarations: [DialogDetailsComponent],
  imports: [
    MatDialogModule,
    ScrollingModule,
    CommonModule,
    OpinIconModule,
    OpinLabelModule,
    OpinButtonModule
  ]
})
export class OpinDialogDetailsModule {}
